import React from "react";
import { Reveal, Overline } from "./motion";
import { useTranslate } from "../context/TranslateContext";

const CHAPTERS = [
  {
    n: "01",
    title: "A Knowledge Graph, not a news feed",
    body: "Every film links to its directors, actors, composers, singers, songs, locations and awards. Follow any thread and the whole universe of Indian cinema unfolds before you.",
  },
  {
    n: "02",
    title: "Regional-first, never Bollywood-only",
    body: "Malayalam, Tamil, Telugu, Kannada, Bengali, Marathi and dozens more stand as equals. This is the cinema of a subcontinent — represented in its full, plural glory.",
  },
  {
    n: "03",
    title: "Multilingual & spoken by design",
    body: "Read any page in your language and press Listen to hear it aloud. Translation and voice are woven into the platform — accessibility as a first principle, not an afterthought.",
  },
];

export const Manifesto = () => {
  const { t } = useTranslate();
  const listenText = CHAPTERS.map((c) => `${c.title}. ${c.body}`).join(" ");

  return (
    <section id="manifesto" className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-12 md:py-40">
      <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
        <div>
          <Overline>The Manifesto</Overline>
          <h2 className="mt-4 max-w-3xl font-display text-4xl font-semibold leading-tight tracking-tight text-cream md:text-6xl">
            {t("More than a website. A ")}<span className="italic text-gradient-gold">{t("living archive")}</span>{t(" of Indian entertainment.")}
          </h2>
        </div>
        
      </div>

      <div className="space-y-16 md:space-y-28">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <div className="relative grid grid-cols-1 items-start gap-6 md:grid-cols-12">
              <span className="pointer-events-none absolute -left-2 -top-16 select-none font-display text-[22vw] font-semibold leading-none text-ink/[0.05] md:-top-24 md:text-[13vw]">
                {c.n}
              </span>
              <div className="relative z-10 md:col-span-5">
                <h3 className="font-display text-3xl font-medium tracking-tight text-cream md:text-4xl">{t(c.title)}</h3>
              </div>
              <div className="relative z-10 md:col-span-6 md:col-start-7">
                <p className="font-body text-lg leading-relaxed text-ash">{t(c.body)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
